// Register the element with the browser
import {StreamBoxHr} from "./stream_box_hr";
import {StreamUserHr} from "./stream_user_hr";
import {StreamBoxPowerCombo} from "./stream_box_power_combo";
import {StreamBoxRowing} from "./stream_box_rowing";
import {StreamUserRowing} from "./stream_user_rowing";

customElements.define('stream-box-hr', StreamBoxHr);
customElements.define('stream-user-hr', StreamUserHr);
customElements.define('stream-box-power-combo', StreamBoxPowerCombo);
customElements.define('stream-box-rowing', StreamBoxRowing);
customElements.define('stream-user-rowing', StreamUserRowing);